import React from 'react';
import Bar from './Bar';
import { Diagram, Columns, Arrow, ArrowCommon, ArrowPrev, ArrowNext, BarPlaceHolder } from './styles'
import Title from '../../Symbols/Title';
import { getCandidateFace } from '../../Utils/Getters';

export default ({
	title,
	roundIndex,
	items = [],
	prev,
	next,
	faces = {}
}) => {
	if (!items.length) {
		return null;
	}

	const max = items[0].percent[roundIndex];
	return <Diagram data-testid="vertical-diagram">
		<Title>{title}</Title>

		<Columns>
			<Arrow><ArrowPrev to={`/obvod/${prev}`} className={ArrowCommon} /></Arrow>
			{items.map(item => <Bar key={item.id} roundIndex={roundIndex} max={max} {...item} face={getCandidateFace(faces, item.id)} />)}
			{items.length === 1 && <BarPlaceHolder>
				Vyhrává v prvním kole
			</BarPlaceHolder>}
			<Arrow><ArrowNext to={`/obvod/${next}`} className={ArrowCommon} /></Arrow>
		</Columns>
	</Diagram>
}
